__turbopack_context__.v({
  "box": "checkbox-module-scss-module__wAOyqa__box",
  "input": "checkbox-module-scss-module__wAOyqa__input",
  "root": "checkbox-module-scss-module__wAOyqa__root",
  "text": "checkbox-module-scss-module__wAOyqa__text",
});
